export const mainProtectedRoute = '/studio/work-orders' as string;
export const mainPublicRoute = '/login' as string;
export const externalRoute = '/studio/work-orders' as string;

export const studioRoute = '/studio';
export const adminRoute = '/admin';

// tammy 2024-01-09: this is not the correct gitbook URL! still testing some features with gitbook and will replace this after that
export const gitBookURL = 'https://zitara.gitbook.io/public-studio-documentation';
